{
	"accounts": "Contas",
	"addAccount": "Adicionar conta",
	"exportExcel": "Exportar para excel",
	"importExcel": "Importar para excel",
	"print": "Imprimir",
	"payable": "A pagar",
	"receivable": "A receber",
	"emptyText": "Nenhuma conta encontrada",
	"isPaidYes": "Sim",
	"isPaidNo": "Não",
	"buttonActions": {
		"markAsPaid": "Marcar como pago",
		"unMarkAsPaid": "Desmarcar como pago",
		"markAsReceived": "Marcar como recebido",
		"unMarkAsReceived": "Desmarcar como recebido",
		"viewDetails": "Ver detalhes",
		"viewEdit": "Ver/Editar"
	},
	"clearAllFilters": "Limpar todos os filtros",
	"clearAllFiltersTooltip": "Remove todos os filtros aplicados e volta para a visualização padrão",
	"status": {
		"all": "Todos",
		"payabled": "Pago",
		"recivabled": "Recebido",
		"late": "Atrasado",
		"conciliated": "Conciliado",
		"payablePending": "A pagar",
		"receivablePending": "A receber",
		"payableToday": "Pagar hoje",
		"receivableToday": "Receber hoje"
	},
	"titleAccountPayable": "Contas a pagar",
	"subtitleAccountPayable": "Gerencie o contas a pagar",
	"excelFileNamePayable": "contas_a_pagar",
	"titleAccountReceivable": "Contas a receber",
	"subtitleAccountReceivable": "Gerencie o contas a receber",
	"excelFileNameReceivable": "contas_a_receber",
	"form": {
		"newAccountPayable": "Nova conta a pagar",
		"editAccountPayable": "Editar conta a pagar",
		"newAccountReceivable": "Nova conta a receber",
		"editAccountReceivable": "Editar conta a receber",
		"informOfPayments": "Informações de pagamento",
		"postingInformation": "Informações de lançamento",
		"lblSupplier": "Fornecedor",
		"lblClient": "Cliente",
		"phSupplier": "Selecionar fornecedor",
		"lblDocNumber": "Número do documento",
		"phDocNumber": "Inserir número do documento",
		"lblInvoiceDate": "Data de competência",
		"phInvoiceDate": "Selecionar data de competência",
		"lblPaymentStatus": "Status de pagamento",
		"lblPaymentDate": "Data de pagamento",
		"phPaymentDate": "Selecionar data de pagamento",
		"lblDueDate": "Data de vencimento",
		"phDueDate": "Selecionar data de vencimento",
		"lblDescription": "Descrição",
		"phDescription": "Inserir descrição",
		"phValue": "Inserir valor",
		"lblValue": "Valor",
		"lblPaymentMethod": "Forma de pagamento",
		"phPaymentMethod": "Selecionar forma de pagamento",
		"lblAccountId": "Conta bancária",
		"phAccountId": "Selecionar conta bancária",
		"lblCostCenter": "Centro de custo",
		"phCostCenter": "Selecionar centro de custo",
		"lblChartAccounts": "Plano de contas",
		"phChartAccounts": "Selecionar plano de contas",
		"ttRequiredWhenFilled": "Ao preencher o campo de valor, o plano de contas se torna obrigatório.",
		"lblInterest": "Juros por atraso",
		"phInterest": "Selecionar juros por atraso",
		"lblFine": "Multa por atraso",
		"phFine": "Selecionar multa por atraso",
		"lblDiscount": "Descontos",
		"phDiscount": "Selecionar descontos",
		"lblPaidValue": "Valor pago",
		"phPaidValue": "Selecionar valor pago",
		"phZeroValue": "0,00",
		"swtIsPaid": "Pago",
		"swtIsReceived": "Recebido",
		"swtConciliated": "Conciliado",
		"swtTotalValue": "Valor total:",
		"recurringPayment": "Pagamento Recorrente",
		"lblRecurringPaymentInterval": "Repetir a cada",
		"phRecurringPaymentInterval": "Digite o intervalo",
		"oneTime": "Valor à vista",
		"recurring": "Valor recorrente",
		"installment": "Valor parcelado",
		"lblInstallmentCount": "Número de parcelas",
		"phInstallmentCount": "Digite o número de parcelas",
		"lblInstallmentInterval": "Repetir a cada",
		"phInstallmentInterval": "Digite o intervalo",
		"lblInstallmentTypeInterval": "Intervalo",
		"phInstallmentTypeInterval": "Selecione o tipo de intervalo",
		"installmentSummary": "Valor total de {{total}} dividido em {{count}} parcelas",
		"lblInstallmentBetween": "Intervalo entre as parcelas",
		"phInstallmentBetween": "Selecione o intervalo",
		"lblInstallmentFirstDueDate": "Vencimento da primeira parcela",
		"lblInstallmentFirstCompetenceDate": "Data de competência da primeira parcela",
		"installmentPeriodicity": {
			"Day": "Diário",
			"Week": "Semanal",
			"Month": "Mensal",
			"Year": "Anual"
		},
		"lblRecurringPaymentTypeInterval": "Intervalo",
		"phRecurringPaymentTypeInterval": "Selecione o tipo de intervalo",
		"lblRecurringPaymentTimes": "Por vez (vezes)",
		"phRecurringPaymentTimes": "Digite o número de vezes",
		"totalRepetition": "Total em ",
		"recurringEnd": "Fim da recorrência:",
		"observation": "Observação",
		"attachment": "Anexo",
		"lblObservation": "Inserir observação",
		"lblAttachment": "Clique ou arraste para anexar um arquivo",
		"lblFinancialFees": "Taxas administrativas",
		"phFinancialFees": "Selecionar taxas administrativas",
		"validations": {
			"dueDate": "Insira a data de vencimento para continuar",
			"value": "Insira o valor para continuar",
			"chartAccounts": "Selecione o plano de contas para continuar",
			"discountGreaterThanBill": "O desconto não pode ser maior que o valor da conta",
			"recurringPaymentInterval": "Insira o intervalo de pagamento recorrente",
			"recurringPaymentTypeInterval": "Selecione o tipo de intervalo de pagamento recorrente",
			"recurringPaymentTimes": "Insira o número de vezes do pagamento recorrente",
			"recurringPaymentTimesMax": "O número máximo de recorrências permitido é 48",
			"installmentCount": "Insira o número de parcelas (mínimo 2)",
			"installmentCountMax": "O número máximo de parcelas permitido é 48",
			"installmentInterval": "Insira o intervalo entre as parcelas",
			"installmentTypeInterval": "Selecione o tipo de intervalo",
			"paymentDate": "Insira a data de pagamento para continuar",
			"paymentAccount": "Selecione a conta de pagamento para continuar",
			"chartAccountRequired": "Selecione o plano de contas para continuar"
		},
		"modalDelete": {
			"title": "Excluir conta",
			"cancelText": "Cancelar",
			"okText": "Excluir conta",
			"message": "A exclusão de conta é uma ação definitiva. Deseja prosseguir com a exclusão?"
		}
	},
	"columns": {
		"docNumber": "Nº DO DOCUMENTO",
		"supplier": "FORNECEDOR",
		"client": "CLIENTE",
		"chartOfAccount": "PLANO DE CONTAS",
		"dueDate": "DATA DE VENCIMENTO",
		"invoiceDate": "DATA DE COMPETÊNCIA",
		"paymentDate": "DATA DE PAGAMENTO",
		"value": "VALOR",
		"situation": "SITUAÇÃO",
		"paymentMethod": "TIPO DE PAGAMENTO",
		"actions": "AÇÕES"
	},
	"chartAccounts": "Plano de contas",
	"placeholderChartAccounts": "Selecionar plano de contas",
	"labelFilter": "Clique para filtrar",
	"selectSupplier": "Filtrar por fornecedor",
	"lblDocNumber": "Filtrar por número do documento",
	"phDocNumber": "Pesquise pelo número documento",
	"lblPaymentDate": "Filtrar por data de pagamento",
	"lblPaymentStatus": "Filtrar por situação de pagamento",
	"phPaymentStatus": "Todas as situações",
	"phSupplier": "Todos os fornecedores",
	"optPaymentStatusAll": "Todas as situações",
	"optPaymentStatusPaid": "Pagos",
	"optPaymentStatusNotPaid": "Não Pagos",
	"optReceivabledStatus": "Recebidos",
	"optNotReceivabledStatus": "Não recebidos",
	"lblDueDate": "Filtrar por data de vencimento",
	"lblInvoiceDate": "Filtrar por data de competência",
	"tzReceived": "Recebidos",
	"tzRecivabledToday": "Receber hoje",
	"tzmaturing": "Pagar hoje",
	"tzDue": "A vencer",
	"tzDelayed": "Vencidos",
	"tzPaid": "Pagos",
	"tzTotal": "Total do período",
	"attatchmentDescription": "Anexe comprovantes de pagamento ou outros documentos relacionados a essa conta para não perdê-los de vista. São permitidos até 4 documentos nos formatos PDF, OFX, XML, XLS, JPG e PNG com até 1.5MB.",
	"attachFile": "Clique para anexar um arquivo",
	"attachImportError": {
		"existingFile": "Arquivo já importado",
		"exceededSize": "Limite de tamanho excedido. O anexo não deve ser maior que 1.5MB"
	},
	"attachModal": {
		"title": "Anexos da conta",
		"noAttachments": "Nenhum anexo encontrado no momento.",
		"table": {
			"columns": {
				"attachedFiles": "Arquivos anexados"
			},
			"successfullyDeletedFile": "Arquivo deletado",
			"errorDeleted": "Não foi possível apagar o arquivo"
		}
	},
	"attachedToChartAccountsModal": {
		"linksPlural": "{{chartAccounts}} vínculos",
		"linksSingular": "1 vínculo",
		"seeLinks": "Ver links",
		"title": "Vínculos com Plano de Contas",
		"description": "Relação de cadastro com os quais esse item está vinculado"
	},
	"modalPayment": {
		"title": "Marcar como pago",
		"titleReceivable": "Marcar como recebido",
		"paymentMethod": "Método de pagamento",
		"selectPaymentMethod": "Selecione o método de pagamento",
		"interests": "Juros por atraso",
		"fine": "Multa por atraso",
		"discount": "Desconto",
		"financialFees": "Taxas administrativas",
		"description": "Selecione a data do pagamento e a conta bancária em que deseja registrar o pagamento",
		"descriptionReceivable": "Selecione a data do recebimento e a conta bancária em que deseja registrar o recebimento",
		"paymentDate": "Data de pagamento",
		"receiptDate": "Data de recebimento",
		"paymentAccount": "Conta bancária",
		"selectAccount": "Selecionar uma conta bancária",
		"required": "Por favor selecione uma data de pagamento",
		"deletedAccount": "Conta deletada",
		"cancel": "Cancelar",
		"confirm": "Confirmar",
		"addAccount": "Adicionar conta",
		"placeholderChartOfAccounts": "Selecionar plano de contas",
		"placeholderZeroValue": "0,00",
		"errors": {
			"paymentDate": {
				"required": "Data de pagamento é obrigatória",
				"invalid": "Formato de data inválido",
				"future": "A data não pode ser posterior à data de abertura do lançamento"
			},
			"paymentAccount": {
				"required": "Conta de pagamento é obrigatória"
			},
			"requiredChartOfAccounts": "Selecione um plano de contas",
			"requiredValue": "Insira o valor",
			"discountGreaterThanBill": "O desconto não pode ser maior que o valor da conta"
		}
	},
	"startDate": "Data inicial",
	"endDate": "Data final",
	"drawer": {
		"titlePayable": "Conta a pagar",
		"titleReceivable": "Conta a receber",
		"titlePayableEdit": "Editar conta a pagar",
		"titleReceivableEdit": "Editar conta a receber",
		"titlePayableView": "Visualizar conta a pagar",
		"titleReceivableView": "Visualizar conta a receber",
		"tabs": {
			"launch": "Lançamento",
			"attachments": "Anexos",
			"recurrencesSummary": "Resumo das recorrências",
			"editHistory": "Histórico de Edição",
			"installment": "Parcela",
			"installmentPaid": "Lançamento",
			"installmentSummary": "Resumo do lançamento total",
			"installmentSummaryPaid": "Resumo do pagamento"
		},
		"sections": {
			"generalInfo": "Informações gerais",
			"details": "Detalhes"
		},
		"attachments": {
			"dropTitle": "Arraste e solte os arquivos aqui",
			"dropSelect": "ou selecione os arquivos",
			"allowedFormats": "São permitidos até 4 documentos nos formatos PDF, OFX, XML, XLS, JPG e PNG com até 1.5MB.",
			"of": "de",
			"filesLabel": "arquivos"
		},
		"markAsPaid": "Lançamento pago?",
		"markAsReceived": "Lançamento recebido?",
		"lblReceiptDate": "Data de recebimento",
		"phReceiptDate": "Selecionar data de recebimento",
		"errors": {
			"paymentDate": {
				"future": "A data não pode ser posterior à data de abertura do lançamento"
			}
		},
		"footer": {
			"totalValue": "Valor total:",
			"submit": "Cadastrar lançamento",
			"submitUpdate": "Salvar alterações",
			"badgeAVista": "À VISTA",
			"badgeRecorrente": "RECORRENTE",
			"recurringWillLaunch": "Serão lançadas",
			"recurringRecurrencesOf": "recorrências de",
			"recurringEvery": "a cada",
			"installmentSplitIn": "parcelado em",
			"installmentTimesEvery": "vezes a cada",
			"installmentParcelValue": "Valor da parcela",
			"installmentTotalOf": "Valor total de",
			"installmentDividedIn": "dividido em",
			"installmentParcelsWord": "parcelas"
		},
		"tooltips": {
			"recurring": "Crie lançamentos repetidos automaticamente em uma frequência definida.",
			"installmentNotRecurring": "Lançamento parcelado não pode ser recorrente.",
			"markAsPaid": "Marque o lançamento como pago e informe os dados do pagamento.",
			"markAsReceived": "Marque o lançamento como recebido e informe os dados do recebimento."
		},
		"recurrencesSummary": {
			"emptyText": "Nenhuma recorrência encontrada.",
			"distributionTitle": "Distribuição das recorrências",
			"columns": {
				"sequence": "Parcela",
				"dueDate": "Data de vencimento",
				"finalValue": "Valor final",
				"status": "Status"
			}
		},
		"installmentSummary": {
			"summaryTitle": "Resumo do lançamento",
			"totalValue": "Valor",
			"type": "Tipo",
			"typeInstallment": "Valor parcelado",
			"typeAVista": "Valor à vista",
			"quitButton": "Quitar todas as parcelas",
			"numberOfInstallments": "Número de parcelas",
			"firstDueDate": "Data de vencimento",
			"interval": "Intervalo entre as parcelas",
			"distributionTitle": "Distribuição das parcelas",
			"emptyText": "Nenhuma parcela encontrada.",
			"hasCharges": "Parcela com juros, multa ou desconto",
			"totalizerTotalAmount": "Valor total das parcelas",
			"totalizerInterest": "Total juros pagos",
			"totalizerFine": "Total multas pagas",
			"totalizerDiscount": "Total descontos obtidos",
			"totalizerPaid": "Valor total pago até agora",
			"blockedBanner": "Não é possível editar este lançamento pois já existem parcelas pagas."
		},
		"editHistory": {
			"tabLabel": "Histórico de Edição",
			"emptyText": "Sem histórico de alterações.",
			"installmentTag": "Parcela {{number}}/{{total}}",
			"columns": {
				"action": "Ação",
				"user": "Usuário",
				"dateTime": "Data e hora"
			},
			"user": {
				"system": "Sistema"
			},
			"fields": {
				"valor": "valor",
				"valorDaParcela": "valor da parcela",
				"juros": "juros por atraso",
				"multa": "multa por atraso",
				"desconto": "desconto",
				"taxasAdministrativas": "taxas administrativas",
				"valorPago": "valor pago",
				"valorRecebido": "valor recebido",
				"dataDeVencimento": "data de vencimento",
				"dataDeCompetencia": "data de competência",
				"dataDePagamento": "data de pagamento",
				"dataDeRecebimento": "data de recebimento",
				"formaDePagamento": "forma de pagamento",
				"formaDeRecebimento": "forma de recebimento",
				"contaBancaria": "conta bancária",
				"fornecedor": "fornecedor",
				"numeroDoDocumento": "número do documento",
				"descricao": "descrição",
				"observacao": "observação",
				"statusDePagamento": "status de pagamento",
				"statusDeRecebimento": "status de recebimento",
				"conciliacao": "conciliação",
				"planoDeContas": "plano de contas"
			},
			"badges": {
				"created": "Lançamento criado",
				"paymentAdded": "Marcou como pago",
				"paymentAddedReceivable": "Marcou como recebido",
				"reconciled": "Conciliado",
				"deleted": "Lançamento removido",
				"unknown": "Lançamento atualizado"
			},
			"events": {
				"updatedTo": "Alterou {{field}} para {{toValue}}"
			}
		},
		"modalDeleteInstallment": {
			"title": "Excluir lançamento parcelado?",
			"message": "Todas as {{total}} parcelas serão removidas. Esta ação não pode ser desfeita.",
			"messageWithPaid": "Todas as {{total}} parcelas serão removidas, incluindo as já pagas — os lançamentos pagos serão estornados do Fluxo de Caixa e da DRE. Esta ação não pode ser desfeita.",
			"cancelText": "Cancelar",
			"okText": "Excluir"
		}
	},
	"modalSettleInstallments": {
		"title": "Quitar todas as parcelas",
		"confirmQuestion": "Certeza que deseja quitar essas parcelas?",
		"message": "Você está quitando o lançamento no valor de {{total}} parcelados em {{count}} vezes.",
		"paymentDate": "Data de pagamento",
		"cancel": "Cancelar",
		"confirm": "Quitar lançamentos"
	}
}
